import { render, staticRenderFns } from "./StoryBigImg.vue?vue&type=template&id=9bb46f58&scoped=true&"
import script from "./StoryBigImg.vue?vue&type=script&lang=js&"
export * from "./StoryBigImg.vue?vue&type=script&lang=js&"
import style0 from "./StoryBigImg.vue?vue&type=style&index=0&id=9bb46f58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb46f58",
  null
  
)

export default component.exports